"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TabControlsWrap = styled_components_1.default.div(({ theme }) => (Object.assign({ cursor: 'pointer', margin: '0 0 0 -1px', border: '1px solid' }, theme.tabs.tabControlsWrap)));
const TabControl = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ display: 'flex' }, theme.tabs.tabControl)));
const TabControls = ({ children, icon, checked = false, onClick = noop_1.default, className, }) => {
    // Legacy dirty fix for: HPWEBN-1325
    // const Control = isBrowser ? TabControlSpan : TabControl;
    return (react_1.default.createElement(TabControlsWrap
    // TODO: Add as="button" prop and refactor styles (broken on search control).
    , { 
        // TODO: Add as="button" prop and refactor styles (broken on search control).
        onClick: onClick, className: className },
        react_1.default.createElement(TabControl, { className: checked ? 'tabControls checked' : 'tabControls' },
            icon && (react_1.default.createElement("span", { className: "icon-wrap" },
                react_1.default.createElement(components_common_icon_1.Icon, { name: icon }))),
            react_1.default.createElement("span", { className: "tab-label" }, children))));
};
exports.default = TabControls;
//# sourceMappingURL=TabControls.js.map